export default __webpack_public_path__ + "static/media/day2_clicks.9e1d9ee6.jpg";